import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import { H2, H3, P } from "../../Partials/Typography"
import ReactHtmlParser from "react-html-parser"
import RightContainer from "../../Partials/RightContainer"
import { spacer } from "../../../styles/sizes"
import SideText from "./SideText"
import { Grid } from "./Grid"
import ImagesRight from "./ImagesRight"
import VideosRight from "./VideosRight"
import UserStoryQuotes from "./UserStoryQuotes"
import { fontSize } from "../../../styles/fonts/fontStyle"

const RightColumnContent = ({ items = [], isKeyDecisions, sideText }) => {
    return (
        <>
            <TextOneColumnOuterContainer>
                <TwoColumnsRightContainer>
                    <Grid>
                        {isKeyDecisions ? (
                            <H2>Key Decisions</H2>
                        ) : (
                            <SideText copy={sideText} />
                        )}
                        <H3SectionContainer>
                            {items.map((item, index) => {
                                console.log("item", item)
                                return (
                                    <ItemWrapper key={index}>
                                        {item.title && (
                                            <H3
                                                isBold
                                                css={css`
                                                    padding-bottom: 2rem !important;
                                                `}
                                            >
                                                {ReactHtmlParser(item.title)}
                                            </H3>
                                        )}
                                        {item.paragraphs &&
                                            item.paragraphs.map(
                                                (text, index) => {
                                                    return (
                                                        <>
                                                            <P
                                                                key={index}
                                                                css={css`
                                                                    padding-bottom: 2rem;
                                                                    &:last-of-type {
                                                                        padding-bottom: 0;
                                                                    }
                                                                `}
                                                            >
                                                                {text.paragraph}
                                                            </P>
                                                        </>
                                                    )
                                                }
                                            )}
                                        {item.images && (
                                            <>
                                                <Wrapper>
                                                    {item.images.map(
                                                        ({
                                                            index,
                                                            ...image
                                                        }) => (
                                                            <ImagesRight
                                                                key={index}
                                                                image={image}
                                                            />
                                                        )
                                                    )}
                                                </Wrapper>
                                            </>
                                        )}
                                        {item.videos && (
                                            <>
                                                <Wrapper>
                                                    {item.videos.map(
                                                        ({
                                                            index,
                                                            ...video
                                                        }) => (
                                                            <VideosRight
                                                                key={index}
                                                                video={video}
                                                            />
                                                        )
                                                    )}
                                                </Wrapper>
                                            </>
                                        )}
                                        {item.quotes && (
                                            <>
                                                <QuotesContainer>
                                                    {item.quotes.map(
                                                        ({
                                                            index,
                                                            ...copy
                                                        }) => (
                                                            <UserStoryQuotes
                                                                key={index}
                                                                copy={copy}
                                                            />
                                                        )
                                                    )}
                                                </QuotesContainer>
                                            </>
                                        )}
                                    </ItemWrapper>
                                )
                            })}
                        </H3SectionContainer>
                    </Grid>
                </TwoColumnsRightContainer>
            </TextOneColumnOuterContainer>
        </>
    )
}
export default RightColumnContent

const TextOneColumnOuterContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`
const H3SectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 800px;
    justify-content: flex-end;

    > :last-of-type {
        padding-bottom: 0;
    }
`
const ItemWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: ${spacer.l};

    > :first-child {
        margin-top: 0;
    }

    > :nth-child(n + 1) {
        padding-bottom: 2rem;
    }

    > :last-of-type {
        padding-bottom: 0;
    }
`

const TwoColumnsRightContainer = styled(RightContainer)`
    justify-content: space-between;
`

const Wrapper = styled.div`
    position: relative;
    display: inline-flex;
    flex-basis: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: ${spacer.l};
`

const QuotesContainer = styled.div`
    &:before {
        content: open-quote;
        font-size: ${fontSize.royal};
    }
    &:after {
        content: close-quote;
        font-size: ${fontSize.royal};
    }
`
